import { render, staticRenderFns } from "./course_account_transfer.vue?vue&type=template&id=d5e131cc"
import script from "./course_account_transfer.vue?vue&type=script&lang=js"
export * from "./course_account_transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports